module.exports = __webpack_public_path__ + "static/img/x10.8440328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/x10.png
// module id = /YxR
// module chunks = 4